const HuddledKlaviyoService = (function () {
  return {
    initAddedToCart
  };

  function initAddedToCart() {
    window.addEventListener('load', function() {
      (function (ns, fetch) {
        ns.fetch = function() {
          const response = fetch.apply(this, arguments);
          response.then(res => {
            if (`${window.location.origin}/cart/add.js`
              .includes(res.url) && res.url !== '') {
                  _addedToCart()
            }
          });
          return response
        }
      }(window, window.fetch));
    });    
  }

  ////////////////////////////////////////////////////////////////////////////

  function _addedToCart() {
    const _learnq = window._learnq || [];

    fetch(`${window.location.origin}/cart.js`)
      .then(res => res.clone().json().then(data => {
        var cart = {
          total_price: data.total_price/100,
          $value: data.total_price/100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price/100,
          items: data.items
        }

        if (typeof item !== 'undefined') {
          cart = { ...cart, ...item };
        }

        _learnq.push(['track', 'Added to Cart', cart]);
        klAjax = false;
      }))
  };

})();
